import {
  ADD_AUTHOR,
  ADD_CATEGORY,
  ADD_SEARCH_ITEM,
  CLEAR_FILTER,
} from './actionType';

const initialState = {
  value: '',
  category: '',
  author: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SEARCH_ITEM:
      return {
        ...state,
        value: action.payload,
      };
    case ADD_CATEGORY:
      return {
        ...state,
        category: action.payload,
      };
    case ADD_AUTHOR:
      return {
        ...state,
        author: action.payload,
      };
    case CLEAR_FILTER:
      return {
        ...state,
        category: '',
        author: '',
      };

    default:
      return state;
  }
};
export default reducer;
